/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { RolesControllerFindOneQueryResponse, RolesControllerFindOnePathParams, RolesControllerFindOne400, RolesControllerFindOne401, RolesControllerFindOne403, RolesControllerFindOne404 } from "../../models/rolesController/RolesControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { rolesControllerFindOne } from "../../clients/rolesService/rolesControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const rolesControllerFindOneQueryKey = (id: RolesControllerFindOnePathParams["id"]) => [{
  url: '/api/v1/roles/:id',
  params: {
    id: id
  }
}] as const;
export type RolesControllerFindOneQueryKey = ReturnType<typeof rolesControllerFindOneQueryKey>;
export function rolesControllerFindOneQueryOptions(id: RolesControllerFindOnePathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = rolesControllerFindOneQueryKey(id);
  return queryOptions<RolesControllerFindOneQueryResponse, ResponseErrorConfig<RolesControllerFindOne400 | RolesControllerFindOne401 | RolesControllerFindOne403 | RolesControllerFindOne404>, RolesControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return rolesControllerFindOne(id, config);
    }
  });
}

/**
 * @summary Get a single role with its granted permission rules
 * {@link /api/v1/roles/:id}
 */
export function useRolesControllerFindOne<TData = RolesControllerFindOneQueryResponse, TQueryData = RolesControllerFindOneQueryResponse, TQueryKey extends QueryKey = RolesControllerFindOneQueryKey>(id: RolesControllerFindOnePathParams["id"], options: {
  query?: Partial<QueryObserverOptions<RolesControllerFindOneQueryResponse, ResponseErrorConfig<RolesControllerFindOne400 | RolesControllerFindOne401 | RolesControllerFindOne403 | RolesControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? rolesControllerFindOneQueryKey(id);
  const query = useQuery({
    ...rolesControllerFindOneQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<RolesControllerFindOne400 | RolesControllerFindOne401 | RolesControllerFindOne403 | RolesControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}